import { useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import Translatable from '@/components/translatable_text/Translatable';

type Props = {
  title: string;
  bgImg: string;
}

function Header({ title, bgImg }: Props) {
  useLayoutEffect(() => {
    const tl = gsap.timeline();
    tl.fromTo('.header', { y: 200 }, { y: 0 }, '+=0.1');
    tl.fromTo(
      '.header .container',
      { opacity: 0, translateY: 40 },
      { opacity: 1, translateY: 0 },
      '-=0'
    );

    // Cleanup function
    return () => {
      tl.kill();
    }
  }, []);


  return (
    <div
      className="header header-3 bg-cover bg-center bg-no-repeat flex items-end d-rotate wow"
      style={{ 
        backgroundImage: `url(${bgImg})`,
        backgroundBlendMode: "multiply",
        backgroundColor: "rgba(0, 0, 0, 0.9)"
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="flex flex-col">
          <div className="w-full">
            <div className="caption py-16 md:py-24 lg:py-32">
              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white rotate-text">
                <Translatable>{title}</Translatable>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
